export default __webpack_public_path__ + "static/media/divineluster.d43f2746.png";